import React from 'react';
import { useField } from 'formik';
import RadioGroup from '..';

const RadioGroupMemo = React.memo(RadioGroup);

const RadioGroupCFormik = (props) => {
	const { name } = props;

	const [field, meta] = useField(name);

	if (!name) return 'For RadioGroup connected to Formik name is required!';

	return (
		<RadioGroupMemo
			value={field.value || ''}
			onChange={field.onChange}
			error={(meta.touched || meta.initialTouched) && meta.error}
			{...props}
		/>
	);
};

RadioGroupCFormik.propTypes = {
	...RadioGroup.propTypes,
};

export default RadioGroupCFormik;
